import React, { useEffect, useState } from 'react';
import { getSpeechMediaUrl, fetchSpeechThumbnail } from '../services/api';

/**
 * UploadedVideoPlayer — plays a member-uploaded video stored in Stratus.
 *
 * The server hands back a short-lived signed GET URL (only to viewers the
 * friends gate allows). A <video src> cannot send our Zoho bearer token, so a
 * signed URL is the only way the browser can stream it; Stratus serves Range
 * requests, so seeking works. The poster comes through the authenticated
 * thumbnail proxy as an object URL.
 */
export default function UploadedVideoPlayer({ speechId, title, hasPoster }) {
  const [src, setSrc] = useState(null);
  const [poster, setPoster] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    getSpeechMediaUrl(speechId)
      .then((res) => { if (!cancelled) setSrc(res?.url || null); })
      .catch(() => { if (!cancelled) setFailed(true); });
    return () => { cancelled = true; };
  }, [speechId]);

  useEffect(() => {
    if (!hasPoster) return undefined;
    let objectUrl = null;
    let cancelled = false;
    fetchSpeechThumbnail(speechId).then((u) => {
      if (cancelled) { if (u) URL.revokeObjectURL(u); return; }
      objectUrl = u;
      setPoster(u);
    }).catch(() => {});
    return () => { cancelled = true; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [speechId, hasPoster]);

  if (failed) {
    return (
      <div className="aspect-video rounded-xl flex items-center justify-center text-sm"
           style={{ background: 'var(--bg-input)', border: '1px solid var(--border-subtle)', color: 'var(--text-faint)' }}>
        Video not available right now
      </div>
    );
  }

  return (
    <div className="aspect-video rounded-xl overflow-hidden" style={{ background: '#000' }}>
      {src && (
        <video
          src={src}
          poster={poster || undefined}
          controls
          preload="metadata"
          playsInline
          title={title}
          className="w-full h-full"
          onError={() => setFailed(true)}
        />
      )}
    </div>
  );
}
